import './App.css';
import Main from './components/Main';
import { BrowserRouter as Router } from 'react-router-dom';
import store from './Redux/store';
import { Provider } from "react-redux";
import { NotificationContainer } from 'react-notifications';
import { MantineProvider } from '@mantine/core';
import ContextProvider from './components/Context/ContextProvider';
// Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// import { getMessaging } from "firebase/messaging/sw";
// import { useEffect } from 'react';


function App() {


  // TODO: Add SDKs for Firebase products that you want to use
  // https://firebase.google.com/docs/web/setup#available-libraries

  // Your web app's Firebase configuration
  // For Firebase JS SDK v7.20.0 and later, measurementId is optional

  // const firebaseConfig = {
  //   apiKey: process.env.REACT_APP_API_KEY,
  //   authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  //   projectId: process.env.REACT_APP_PROJECT_ID,
  //   storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  //   messagingSenderId: process.env.REACT_APP_MESSAGE_SENDER_ID,
  //   appId: process.env.REACT_APP_APP_ID,
  //   measurementId: process.env.REACT_APP_MEASUREMENT_ID
  // };




  // useEffect(() => {
  //   // Initialize Firebase
  //   const app = initializeApp(firebaseConfig);
  //   const analytics = getAnalytics(app);

  //   const messaging = getMessaging(firebaseConfig);
  //   messaging.onBackgroundMessage(function (payload) {
  //     console.log("Received background message ", payload);

  //     const notificationTitle = payload.notification.title;
  //     const notificationOptions = {
  //       body: payload.notification.body,
  //       // icon: "/logo192.png",
  //     };

  //     // eslint-disable-next-line no-restricted-globals
  //     return self.registration.showNotification(
  //       notificationTitle,
  //       notificationOptions
  //     );
  //   });
  // }, [])




  return (
    <Provider store={store}>
      <ContextProvider>
        <MantineProvider theme={{
          colors: {
            'bright-pink': ['#F0BBDD', '#ED9BCF', '#EC7CC3', '#ED5DB8', '#F13EAF', '#F71FA7', '#FF00A1', '#E00890', '#C50E82', '#AD1374'],
          },
        }}>
          <Router>
            <Main />
          </Router>
          <NotificationContainer />
        </MantineProvider>
      </ContextProvider>
    </Provider>
  );
}



export default App;
